/** USD currency formatting, shared across the grids and exports. */

/**
 * Formats a number as USD. `fractionDigits` fixes both the minimum and maximum
 * decimals, so 0 gives whole dollars and 2 gives cents; pass more options
 * through `extra` when a caller needs them.
 */
export const formatUsd = (
  value: number,
  fractionDigits: number,
  extra?: Intl.NumberFormatOptions,
): string =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    ...extra,
  }).format(value);
